import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result } from '@digibricks/domains';
import { AnswerReport } from './answer-report';
export var MultipleChoiceAnswerReport = /*#__PURE__*/function (_AnswerReport) {
  _inherits(MultipleChoiceAnswerReport, _AnswerReport);

  var _super = _createSuper(MultipleChoiceAnswerReport);

  function MultipleChoiceAnswerReport() {
    _classCallCheck(this, MultipleChoiceAnswerReport);

    return _super.apply(this, arguments);
  }

  _createClass(MultipleChoiceAnswerReport, [{
    key: "selectedAnswerPercentage",
    get: function get() {
      return this.props.selectedAnswerPercentage;
    }
  }, {
    key: "totalSelectedAnswers",
    get: function get() {
      return this.props.totalSelectedAnswers;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.selectedAnswerPercentage,
        argumentName: 'Selected Answer Percentage'
      }, {
        argument: props.totalSelectedAnswers,
        argumentName: 'Total Selected Answers'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new MultipleChoiceAnswerReport(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var selectedAnswerPercentage = data.selectedAnswerPercentage,
            totalSelectedAnswers = data.totalSelectedAnswers;

        var basePropsOrError = _get(_getPrototypeOf(MultipleChoiceAnswerReport), "createBaseProps", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var baseProps = basePropsOrError.getValue();
        var multipleChoiceAnswerReportOrError = this.create(_objectSpread(_objectSpread({}, baseProps), {}, {
          selectedAnswerPercentage: selectedAnswerPercentage,
          totalSelectedAnswers: totalSelectedAnswers
        }));

        if (multipleChoiceAnswerReportOrError.isFailure) {
          return Result.fail(multipleChoiceAnswerReportOrError.error);
        }

        var multipleChoiceAnswerReport = multipleChoiceAnswerReportOrError.getValue();
        return Result.ok(multipleChoiceAnswerReport);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MultipleChoiceAnswerReport;
}(AnswerReport);